import { NgModule } from '@angular/core';
import { PaymentCmsComponents } from '@core/const';
import { PAYMENT_FEATURE_LAZY, PAYMENT_UI_LAZY } from '@payment/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        [PAYMENT_FEATURE_LAZY]: {
          module: () => import('./sdvor-payment-feature.module').then((m) => m.SdvorPaymentFeatureModule),
        },
        [PAYMENT_UI_LAZY]: {
          module: () => import('./sdvor-payment-ui.module').then((m) => m.SdvorPaymentUiModule),
          cmsComponents: Object.values(PaymentCmsComponents),
        },
      },
    }),
  ],
})
export class SdvorPaymentShellModule {}
